/* @ngInject */

export default (webpage, workflowsService, navigationService) => {
  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Home');

  /*
   * Retrieve Available Workflows Data
   * --------------------------------------------------------------------------------
   */
  workflowsService.getAvailable({ isActive: true }).then(function (workflows) {
    navigationService.goToLastWorkflow(workflows);
  });
};
